import { defineMessages } from 'react-intl';

export default defineMessages({
    bindingScripts: {
        id: 'ml.gateway.quoteandbind.common.bindingScripts.Binding Scripts',
        defaultMessage: 'Binding Scripts'
    },
    nextText: {
        id: 'ml.gateway.quoteandbind.common.bindingScripts.nextText',
        defaultMessage: 'We\'ll {addlInfo} next'
    },
    additionalInformation: {
        id: 'ml.gateway.quoteandbind.common.bindingScripts.sign required documents',
        defaultMessage: 'sign required documents'
    },
    genericScriptsCheckbox: {
        id: 'ml.gateway.quoteandbind.common.bindingScripts.I have read all scripts to the applicant exactly as they appear above',
        defaultMessage: ' I have read all scripts to the applicant exactly as they appear above'
    },
    autopayScriptsCheckbox: {
        id: 'ml.gateway.quoteandbind.common.bindingScripts.I have read the auto pay script to the applicant exactly as it appears above.',
        defaultMessage: ' I have read the auto pay script to the applicant exactly as it appears above.'
    }
});